import {
  ImageProps,
  Slide,
  chartOptionsToBase64Svg,
} from '@features/powerpoint';
import { contentSlideHeader } from '../../../../../utils';
import { buildChartOptions } from '@configurations/campaignAnalytics/timeToFirstVisitChart';
import { CampaignAnalyticsSlideProps } from '../build-campaign-analytics-slides';
import { CHART_HEIGHT, CHART_WIDTH } from './charts';
import { Options } from 'highcharts';

export const timeToFirstVisitChartSlide = (
  props: CampaignAnalyticsSlideProps
): Slide => {
  const chartOptions: Options = buildChartOptions(
    props.campaignAnalyticsReport.timeToFirstVisitByDay.data.toSorted(
      (a, b) => a.daysAfterAdExposure - b.daysAfterAdExposure
    ),
    true
  );

  const timeToFirstVisitChart: string = chartOptionsToBase64Svg({
    chartOptions,
    height: CHART_HEIGHT,
    width: CHART_WIDTH,
  });

  const images: ImageProps[] = [
    {
      data: timeToFirstVisitChart,
      w: 11.85,
      h: 5.22,
      x: 0.74,
      y: 1.66,
    },
  ];

  return {
    slideMaster: props.slideMaster,
    texts: [contentSlideHeader('Time To First Visit')],
    images,
  };
};
